<template>
    <div class="loaded bg-dark-background-1">
        <slot />
    </div>
</template>
<script>
</script>

